import React from "react";
import logo from "../assets/yivo_noBgColor.png";
import { Link } from "react-router-dom";

const Home = () => {
  return (
    <div className="flex flex-col min-h-screen bg-gray-900 text-white">
      {/* Logo Section */}
      <div className="flex flex-col justify-center items-center px-4 py-12 min-h-[65vh]">
        <img
          src={logo}
          alt="Yivo Logo"
          className="w-[70%] sm:w-[50%] md:w-[30%] h-auto mb-6"
        />
      </div>

      {/* Intro Section */}
      <section className="w-full bg-gray-800 px-6 py-8 sm:py-12 text-center">
        <div className="max-w-2xl mx-auto">
          <h2 className="text-xl sm:text-2xl font-semibold mb-4 text-purple-400">
            What is Yivo?
          </h2>
          <p className="text-gray-300 mb-6 text-sm sm:text-base leading-relaxed">
            Yivo is a cybersecurity platform currently focused on centralizing threat intelligence from across the web. It helps analysts research indicators of compromise, monitor real-time threats, and share findings. Whether you're a security professional or a curious observer, Yivo makes threat intel more accessible.
          </p>
          <Link
            to="/register"
            className="inline-block bg-purple-600 hover:bg-purple-700 text-white font-medium py-2 px-6 text-sm sm:text-base rounded transition"
          >
            Sign Up for Free
          </Link>
        </div>
      </section>

      {/* Help Section */}
      <section className="w-full bg-gray-600 px-6 py-8 sm:py-12 text-center shadow-inner">
        <div className="max-w-2xl mx-auto">
          <h2 className="text-xl sm:text-2xl font-semibold mb-4">
            Need Help Getting Started?
          </h2>
          <p className="text-sm sm:text-base mb-5 text-gray-300">
            Learn how to use the Yivo platform through our step-by-step guide.
          </p>
          <Link
            to="/help"
            className="inline-block bg-purple-600 hover:bg-purple-700 text-white font-medium py-2 px-5 text-sm sm:text-base rounded transition"
          >
            Go to Help Page
          </Link>
        </div>
      </section>

      {/* Donate Section */}
      <section className="w-full bg-gray-700 px-6 py-8 sm:py-12 text-center">
        <div className="max-w-2xl mx-auto">
          <h2 className="text-xl sm:text-2xl font-semibold mb-4 text-green-400">
            Support Yivo
          </h2>
          <p className="text-sm sm:text-base mb-6 text-gray-300">
            Yivo is a solo-developed platform, built and maintained with care.
            Your donation helps cover hosting costs, ongoing upkeep, and continued improvements.
            Every contribution makes a big difference and is deeply appreciated.
          </p>
          <a
            href="https://paypal.me/yivointel?country.x=US&locale.x=en_US"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-green-600 hover:bg-green-700 text-white font-medium py-2 px-6 text-sm sm:text-base rounded transition"
          >
            Donate
          </a>
        </div>
      </section>
    </div>
  );
};

export default Home;
